document.addEventListener('DOMContentLoaded', () => {
    // Add verified review badge to carousel reviews
    const itemTitleWrappers = document.querySelectorAll('.jdgm-carousel-wrapper .jdgm-carousel-item .jdgm-carousel-item__reviewer-name-wrapper');

    const verifiedCheckmark = `
      <svg width="16" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="m8 1.167 1.5 1.666 2.166-.666.5 2.166 2.167.5L13.666 7l1.667 1.5-1.667 1.5.667 2.167-2.167.5-.5 2.166-2.167-.666L8 15.833l-1.5-1.666-2.166.666-.5-2.166-2.167-.5L2.333 10 .666 8.5 2.333 7l-.667-2.167 2.167-.5.5-2.166 2.166.666L8 1.167Z" fill="#42A5F5"/>
        <path d="M11.533 5.367 6.999 9.9 5.133 8.033l-.934.934 2.8 2.8L12.466 6.3l-.933-.933Z" fill="#E3F2FD"/>
      </svg>`;

    const verifiedReviewBadge = `
      <div class="jdgm-verified-badge">
        ${verifiedCheckmark}
        <span>Ověřená recenze</span>
      </div>`;

    itemTitleWrappers.forEach((itemTitleWrapper) => {
      // No duplicate badges
      if (itemTitleWrapper.querySelector('.jdgm-verified-badge')) {
        return;
      }

      itemTitleWrapper.insertAdjacentHTML('beforeend', verifiedReviewBadge);
    });

    // Add reviews score to carousel reviews title
    const allReviewsRating = document.querySelector('.jdgm-all-reviews-rating');
    const numberOfReviews = document.querySelector('.jdgm-carousel-number-of-reviews');

    const reviewsScore = allReviewsRating?.getAttribute('data-score');

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const reviewsLink = numberOfReviews?.querySelector('a');

          if (reviewsScore
              && reviewsLink
              && !reviewsLink.textContent.trim().startsWith(reviewsScore)) {
            reviewsLink?.insertAdjacentHTML('afterbegin', `<span class="jdgm-carousel-number-of-reviews__score">${reviewsScore} </span>`);

            observer.disconnect();
          }
      });
    });

    if (numberOfReviews) observer.observe(numberOfReviews, {
      childList: true,
      subtree: true,
    });
  });